import React from "react";
import { Group, Text } from "@mantine/core";
import { IconStar } from "@tabler/icons";

/** Trustpilot-style per-level hex colors */
export const STAR_HEX: Record<number, string> = {
  1: "#e03131",
  2: "#e8590c",
  3: "#f59f00",
  4: "#82c91e",
  5: "#2f9e44",
};

export const STAR_BG_LIGHT: Record<number, string> = {
  1: "rgba(224,49,49,0.06)",
  2: "rgba(232,89,12,0.06)",
  3: "rgba(245,159,0,0.06)",
  4: "rgba(130,201,30,0.06)",
  5: "rgba(47,158,68,0.06)",
};

export const STAR_BG_DARK: Record<number, string> = {
  1: "rgba(224,49,49,0.10)",
  2: "rgba(232,89,12,0.10)",
  3: "rgba(245,159,0,0.10)",
  4: "rgba(130,201,30,0.10)",
  5: "rgba(47,158,68,0.10)",
};

export const STAR_LABELS: Record<number, string> = {
  1: "Poor",
  2: "Fair",
  3: "Average",
  4: "Good",
  5: "Excellent",
};

export function StarRating({
  rating,
  size = 16,
  showNumeric,
}: {
  rating: number;
  size?: number;
  showNumeric?: boolean;
}) {
  const hex = STAR_HEX[rating] || "#868e96";
  return (
    <Group spacing={3} noWrap>
      {[1, 2, 3, 4, 5].map((i) => (
        <IconStar
          key={i}
          size={size}
          color={i <= rating ? hex : "#dee2e6"}
          fill={i <= rating ? hex : "none"}
          strokeWidth={1.5}
        />
      ))}
      {showNumeric && (
        <Text size="xs" weight={700} ml={4} sx={{ color: hex }}>
          {rating}.0
        </Text>
      )}
    </Group>
  );
}
